module.exports = __webpack_public_path__ + "img/xi.ae427341.png";